import {SET_ENERGY_DEMAND} from '../../actions/action';
import {AnyAction} from 'redux';


export const getEnergyDemand = state => state.energyDemand;



/**
 * reducer: set the current energy demand
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function energyDemand(state: number = 150, action: AnyAction) : number
{
    switch (action.type)
    {
        case SET_ENERGY_DEMAND:
        {
            const {payload} = action;
            const {demand} = payload;

            return demand || state;
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/energy/energyDemand.ts